export default __webpack_public_path__ + "scripts/resource/85fc30d087857a05c7ed74ca5e4a69ef.svg";